export default __webpack_public_path__ + "static/media/background_text.38916ba3.png";